<template>
	<div class="container-fluid">
		<time-logs-toolbar heading="Time Logs"></time-logs-toolbar>

		<time-log-table
			:show-job="true"
			:show-user="true"
			:show-user-classification="true"
			:filtering-tools="true"
			:collapse-buttons="true"
			:default-filter-values="{dateFrom: defaultDateFromFilter}"
			:editable="editable">
		</time-log-table>

	</div>
</template>

<script>
import TimeLogsToolbar from "./TimeLogsToolbar"
import TimeLogTable from "../../components/super_components/TimeLogTable"

import TimeLogMixins from "@/mixins/TimeLogMixins.js"

export default {

	name: 'TimeLogs',
	components: {
		TimeLogsToolbar,
		TimeLogTable
	},
	mixins: [TimeLogMixins],
	watch: {
		'$store.timeLogSettings'() {
			this.$forceUpdate()
		}
	},
	computed: {
		editable() {
			//check TimeLog perms to see if this user can edit them or not
			if (this.getUserRoleType() == "Admin" || this.hasModulePermWrite("TimeLogs"))
				return true
			else
				return false
		}
	},
	created() {
		let vm = this
		this.getJSON("TimeLogSetting/get").then(response => {
			if (response.data.length > 0) {
				vm.$store.timeLogSettings = response.data[0]
			}
			else {

				vm.$store.timeLogSettings = {
					uses_overtime_15x: false,
					uses_overtime_2x: false,
					uses_overtime_25x: false,
					interval: null,
					intitial_payday: null
				}
			}
		})

	}
}
</script>
